import * as d3 from 'd3'
import theme from 'theme'
import { resolveThemeColor } from 'theme/config'
import { getActiveThemeMode } from 'theme/themeMode'
// import { chartHeightStart } from '../chart-utils'

/*
 * The add-label button is drawn this far right of the centre of the stripe it belongs to, so a click
 * on it reports an x from the next stripe once stripes are narrower than twice this.
 * */
export const ADD_EVENT_BUTTON_X_OFFSET = 20

interface Props {
  addEventButton: d3.Selection<SVGGElement, unknown, null, undefined>
  addEventButtonTooltip: d3.Selection<SVGGElement, unknown, null, undefined>
  height: number
}

export const appendButtonAddEvent = ({ addEventButton, addEventButtonTooltip, height }: Props) => {
  const mode = getActiveThemeMode()
  /* Add Event Button */
  addEventButton
    .append('circle')
    .attr('class', 'add-button-circle')
    .attr('cy', height)
    .attr('r', 12)
    .attr('fill', resolveThemeColor('card-fill-primary', mode))
    .attr('stroke', resolveThemeColor('button-circle-border', mode))
    .attr('stroke-width', 2.33)
    .attr('filter', 'drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.30)) drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.15))')
    .attr('display', 'block')
  addEventButton
    .append('rect')
    .attr('class', 'add-button-rect-hor')
    .attr('x', 1)
    .attr('y', height - 1)
    .attr('width', 11)
    .attr('height', 2.33)
    .attr('fill', resolveThemeColor('text-primary', mode))
  addEventButton
    .append('rect')
    .attr('class', 'add-button-rect-ver')
    .attr('x', 1)
    .attr('y', height - 5.5)
    .attr('width', 2.33)
    .attr('height', 11)
    .attr('fill', resolveThemeColor('text-primary', mode))

  /* Button Hover Tooltip */
  addEventButtonTooltip
    .append('rect')
    .attr('class', 'add-button-rect-tooltip-wrapper')
    .attr('y', height + 17)
    .attr('width', 159)
    .attr('height', 40)
    .attr('fill', resolveThemeColor('tooltip-bg', mode))
    .attr('rx', 8)
    .style('transform', 'translateX(-15px)')

  addEventButtonTooltip
    .append('text')
    .attr('class', 'add-button-rect-tooltip-text')
    .attr('y', height + 42)
    .style('fill', resolveThemeColor('text-primary', mode))
    .style('font-size', theme.typography.fontSize.large)
    .style('font-family', theme.typography.fontFamily.primary)
    .style('font-weight', `${theme.typography.fontWeight.bold}`)
    .style('line-height', '20px')
    .style('letter-spacing', '0.1px')
    .text('Create New Label')
}
